import { Component, OnInit, OnDestroy, Input, Output } from "@angular/core";
import { EventEmitter } from "events";
import { ValidationMessage } from "app/validation";
import { Observable, Subscription } from "rxjs";
import { TacticAssetslistItemDTO, TacticCatalogSearch, TacticId } from "app/client-core/dtos/tactics.model";
import { PaginationInfo } from "app/client-core/api-response-models";
import { DocumentUrlPipe } from "app/shared/pipes";
import { TacticService } from "app/client-core/services/tactic.service";
import { CampaignService, DocumentService } from "app/client-core/services";
import { UserService } from "app/client-core/services/user.service";
import { ProgramService } from "app/client-core/services/program.service";
import { BsModalService } from "ngx-bootstrap";
import { AuthService } from "app/+auth/auth.service";
import { AssetEmailModalComponent } from "app/+assets/asset-email-modal/asset-email.modal.component";


@Component({
    selector: 'campaign-tactic-tab-assets-grid',
    templateUrl: './grid.component.html',
    styleUrls: ['./grid.component.scss']
})
export class CampaignGridAssetsComponent implements OnInit, OnDestroy {

    @Input()
    campaignThemeId: number;

    @Output() itemClicked = new EventEmitter();

    public validationMessages: ValidationMessage;
    submitting: boolean;

    @Output() imageClicked = new EventEmitter();

    rows: Observable<TacticAssetslistItemDTO[]>;

    paginationInfo: PaginationInfo;
    pageSizeOptions: Array<number> = [10, 25, 50, 100, 250];
    categories: Array<any>;

    _searchModel: TacticCatalogSearch;

    private searchSubscription: Subscription;
    private viewCampaignThemeModalConfig = {
        animated: true,
        keyboard: false,
        backdrop: true,
        ignoreBackdropClick: true,
        class: "modal-lg"
    };
    docmentUrlPipe: DocumentUrlPipe;
    @Input() showNoDataMessage: boolean;
    @Input() noDataMessage: string;
    hasData: boolean;

    public applySearchModel() {
        this.paginationInfo = new PaginationInfo(0, 50);
        this.tacticService.newTacticSearchModelArrived.next(this._searchModel);
    }

    public search(): any {

        this._searchModel.campaignThemeId = this.campaignThemeId;
        // tslint:disable-next-line:max-line-length
        let params: any = Object.assign({ pageSize: this.paginationInfo.pageSize, pageIndex: this.paginationInfo.pageIndex }, this._searchModel);
        console.log('>>applySearchModelChanges', params)
        this._getCampaignThemeTactics(params);
    }

    constructor(
        private tacticService: TacticService,
        private userService: UserService,
        private modalService: BsModalService,
        private documentService: DocumentService,
        private authService: AuthService
    ) {
        this.paginationInfo = new PaginationInfo(0, 50);
        this.docmentUrlPipe = new DocumentUrlPipe(documentService, authService);
    }

    ngOnInit() {
        this._searchModel = new TacticCatalogSearch();
        this._searchModel.campaignThemeId = this.campaignThemeId;
        this.tacticService.getTacticCategories().subscribe(response => {
            this.categories = response.data;
        })
        this.searchSubscription = this.tacticService.newTacticSearchModelArrived
            .debounceTime(800)
            .subscribe((model) => {
                this._searchModel = model;
                this.search();
            });

        this.search();
    }

    ngOnDestroy() {
        if (this.searchSubscription)
            this.searchSubscription.unsubscribe();
    }

    private _getCampaignThemeTactics(event: any = {}): void {
        this.submitting = true;

        //this.campaignService.getCampaignThemeTactics(event)
        this.tacticService.getCampaignTacticsAssets(event)
            .subscribe(res => {
                if (!res.hasError) {
                    this.paginationInfo = PaginationInfo.createForApiPagedResponse(res.data);
                    const items = res.data.items;
                    if (this.paginationInfo.hasNextPage) {
                        items.push({
                            id: 0,
                            placeholder: true,
                            tacticTacticName: 'placeholder'
                        } as TacticAssetslistItemDTO);
                    }
                    this.rows = Observable.of(items);
                    this.submitting = false;
                    this.hasData = items && items.length > 0;
                } else {
                    this.validationMessages = new ValidationMessage(res.error, true, "Data could not be retrieved");
                }
            },
                (err: any) => {
                    this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
                },
                () => {
                    this.submitting = false;
                });
    }

    addToFavorite(value: number): void {
        let tacticId = new TacticId(value);
        this.userService.AddTacticAsFavorite(tacticId)
            .subscribe(res => {
                if (!res.hasError && res.data) {
                    this.validationMessages = new ValidationMessage(null, true, "Added favorite")
                        .pushMessage("Successfully added as a favorite")
                        .isSuccess();
                    this.tacticService.newFavoriteAdded.next(new TacticId(res.data));
                } else {
                    this.validationMessages = new ValidationMessage(res.error, true, "Error occured");
                }
            },
                (err: any) => {
                    this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
                },
                () => {
                    this.submitting = false;
                });

    }

    viewDetails(value: number): void {
        console.log('grid>>viewDetails TacticId', value);
        let tacticId = new TacticId(value);
        this.tacticService.showTacticInfo.next(tacticId);
    }

    selectTactic(value: number, productType): void {
        let tacticId = new TacticId(value);
        this.tacticService.selectTacticInfo.next({id: tacticId, productType: productType});
    }

    onPageSizeChange(size: number) {
        console.log('grid>>onPageSizeChange', size);
        this.paginationInfo.pageSize = size;
        this.search();
    }

    firstPage() {
        if (!this.paginationInfo.hasPreviousPage)
            return;

        this.paginationInfo.pageIndex = 0;
        this.search();
    }

    previousPage() {
        if (!this.paginationInfo.hasPreviousPage)
            return;

        this.paginationInfo.pageIndex = this.paginationInfo.pageIndex - 1;
        this.search();
    }

    nextPage() {
        if (!this.paginationInfo.hasNextPage)
            return;

        this.paginationInfo.pageIndex = this.paginationInfo.pageIndex + 1;
        this.search();
    }

    lastPage() {
        if (!this.paginationInfo.hasNextPage)
            return;

        this.paginationInfo.pageIndex = this.paginationInfo.totalPages - 1;
        this.search();
    }

    onItemClicked(item) {
        if (item.placeholder) {
            this.nextPage();
        }
    }

    OpenAssetEmailModal(item) {
        const initialState = {
            tacticId: item.tacticId,
            downloadURL: item.downloadURL,
            tacticName: item.tacticTacticName
        }
        this.modalService.show(AssetEmailModalComponent, Object.assign({}, this.viewCampaignThemeModalConfig, { initialState }));
        event.stopPropagation();
    }

    onImageClicked(item: TacticAssetslistItemDTO) {
        const url = this.docmentUrlPipe.transform(item.tacticDocumentId, 'assets/img/thumbnails/thumbnail-300x200.png');
        this.imageClicked.emit(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/campaign-modal-component/assets/grid.component.ts